import React from 'react'
import { Button } from '@lmc/ui-kit'

interface EmarNextStepButtonProps {
  handleNext: () => void
  // Add other props as needed
}

const EmarNextStepButton: React.FC<EmarNextStepButtonProps> = (props) => {
  const { handleNext } = props

  return (
    <Button onClick={handleNext} variant="primary">
      Next Step
    </Button>
  )
}

export default EmarNextStepButton
